module.exports = __webpack_public_path__ + "static/china-67216d838c930b3ee3de22c464df3470.png";